<template>
  <div class="resource-bd tb" v-if="funcView.resource_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button v-if="funcView.resource_add" type="primary" icon="el-icon-plus" @click="addResource">{{ funcView.resource_add }}</el-button>
        </el-form-item>
        <el-form-item v-if="funcView.expt_resourceinfo" style="float: right; margin-right: 0">
          <el-button class="table-set" @click="exportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_resource.zymczybbxxjrbbh')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table height="100%" :slots="['resourceName', 'support', 'action']" :index="true" :data="resourceList" :column="tableColumn" @filter="filterChange" @sort="sortChange">
        <template v-slot:resourceName="scope">
          <span v-if="funcView.resource_preview" @click="resourceView(scope.row.resourceId)" style="color: #00a2df; cursor: pointer">{{ scope.row.resourceName }}</span>
          <span v-else>{{ scope.row.resourceName }}</span>
        </template>
        <template v-slot:support="scope">
          <el-popover width="650" placement="bottom" trigger="hover"  v-if="scope.row.machineVersionList">
            <support-protocol-detail :data="scope.row.machineVersionList" tableCode="resource_protocol_detail"></support-protocol-detail>
            <span style="text-align: center; padding: 0 10px" class="table-link" slot="reference">{{ $t('Common.com_detail') }}</span>
          </el-popover>
          <span  style="text-align: center; padding: 0 10px" v-else>{{ $t('Common.com_detail') }}</span>
        </template>
        <template slot="action" slot-scope="scope">
          <!--
            发布
            资源类别为 固件，发布状态为否时可用
          -->
          <el-button type="text" size="mini" v-if="funcView.resource_release && `${scope.row.resourceClass }`==='1' && `${scope.row.isPublish}`==='0'" @click="releaseResource(scope.row)">{{funcView.resource_release}}</el-button>
          <!--
            取消发布
            资源类别为 固件，发布状态为是时可用
          -->
          <el-button type="text" size="mini" v-if="funcView.resource_cancelRelease && `${scope.row.resourceClass }`==='1' && `${scope.row.isPublish}`==='1'" @click="cancelReleaseResource(scope.row)">{{funcView.resource_cancelRelease}}</el-button>
          <el-button type="text" size="mini" v-if="funcView.resource_edit && `${scope.row.state}`!=='3'" @click="editResource(scope.row.resourceId)">{{ funcView.resource_edit }}</el-button>
          <el-button type="text" size="mini" v-if="funcView.resource_delete && !scope.row.state && `${scope.row.state}`!=='3'" @click="deleteResource(scope.row)">{{ funcView.resource_delete }}</el-button>
          <el-button v-if="!scope.row.state && funcView.resource_open && `${scope.row.state}`!=='3'" type="text" size="mini" @click="onOpen(scope.row)">{{ funcView.resource_open }}</el-button>
          <el-button v-if="scope.row.state && funcView.resource_close && `${scope.row.state}`!=='3'" type="text" size="mini" @click="onClose(scope.row)">{{ funcView.resource_close }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <resource-detail-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></resource-detail-dialog>

    <resource-item-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="getFirmwarePage"></resource-item-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import supportProtocolDetail from '@/pages/dms/components/support_protocol_detail';
import resourceDetailDialog from './children/resource_detail_dialog';
import resourceItemDialog from './children/resource_item_dialog';

export default {
  name: 'resource',
  components: { resourceDetailDialog, supportProtocolDetail, resourceItemDialog },
  data() {
    return {
      tableCode: 'resource_manage',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
      },
      resourceList: [],
      totalRows: null,
      isLoading: false,

      // 查看固件
      dialogVisible: false,
      dialogModel: {
        data: {},
      },
      // 新增
      dialogVisible1: false,
      dialogModel1: {},
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFirmwarePage();
    this.getTableColumn();
    this.getFuncView();

  },
  methods: {
    checkDetail(scope) {
      const refsName = `popover${scope.row.resourceId}`;
      this.$refs[refsName].getInfo();
    },
    // 启用
    onOpen(row) {
      const tips = this.$t('dms_resource.nqdyqyxzdzym');
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.resourceUpdateState}/${row.resourceId}/1`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_edit_success'),
          });
          this.getFirmwarePage();
        });
      });
    },
    // 禁用
    onClose(row) {
      const tips = this.$t('dms_resource.nqdyjyxzdzym');
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.resourceUpdateState}/${row.resourceId}/0`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_edit_success'),
          });
          this.getFirmwarePage();
        });
      });
    },
    exportTable() {
      this.$exportFlie(apis.resourceExport, this.formSearch).then(() => {});
    },

    listAdapter(list) {
      return list.map((item) => {
        item.details = [];
        return item;
      });
    },
    // 获取固件列表
    getFirmwarePage: function () {
      this.isLoading = true;
      this.$getJSON(apis.resourcePage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.resourceList = this.listAdapter(res.data.list);
        this.totalRows = res.data.total;
      });
    },
    // 编辑固件
    // editFirmware: function ({ resourceId = {} }) {
    //   this.jump('/iot/resource/edit', { resourceId: resourceId });
    // },
    // 查看固件
    resourceView: function (resourceId) {
      this.dialogVisible = true;
      this.dialogModel.data.resourceId = resourceId;
      this.dialogModel.title = this.$t('dms_resource.zi_yuan_xin_xi');
      // this.dialogModel.type = 'seeStatus';
    },
    releaseResource: function (row) {
      const tpl = this.$t('dms_resource.nqdfbsxdomhbszwffbzt', [row.resourceName,this.getDicValue('iot_protocol_class', row.protocolClass),this.getDicValue('iot_tsl_resource_type', row.resourceType)]);
      this.$showConfirm(tpl)
        .then(() => {
          this.$postJSON(`${apis.resourcePublish}/${row.resourceId}/1`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getFirmwarePage();
          });
        })
        .catch(() => {});
    },

    cancelReleaseResource: function (row) {
      const tpl = this.$t('dms_resource.nqdqxfbsxdom', [row.resourceName]);
      this.$showConfirm(tpl)
        .then(() => {
          this.$postJSON(`${apis.resourcePublish}/${row.resourceId}/0`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getFirmwarePage();
          });
        })
        .catch(() => {});
    },
    // 删除固件
    deleteResource: function (data) {
      this.$showConfirm(this.$t('dms_resource.nqdyscxzdzym'))
        .then(() => {
          this.$postJSON(`${apis.resourceUpdateState}/${data.resourceId}/3`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getFirmwarePage();
          });
        })
        .catch(() => {});
    },
    // 新增
    addResource: function () {
      this.dialogModel1.type = 'add';
      this.dialogVisible1 = true;
    },
    // 编辑
    editResource: function (resourceId) {
      this.dialogModel1.type = 'edit';
      this.dialogModel1.data = {
        resourceId,
      };
      this.dialogVisible1 = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getFirmwarePage();
    },
    // 获取产品协议列表
    // getProtocolList: function (row) {
    //   this.$getJSON(apis.resourceProtocolList, {
    //     resourceId: row.resourceId,
    //   }).then((res) => {
    //     const list = res.data;
    //     this.$set(row, 'protocolList', list);
    //     this.$set(row, 'popover', true);
    //   });
    // },
    // hidePopover: function (row) {
    //   this.$set(row, 'popover', false);
    // },
  },
};
</script>

<style lang="scss"></style>
